import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import MemberReport from "../../components/pt-trials/member-report/MemberReport";
import HelmetWrapper from "../../HelmetWrapper";

const LiveMemberReport = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live Member Report">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MemberReport userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default LiveMemberReport;
